import { mapGetters, mapActions } from "vuex";
import FilterSection from "@/components/Synonym/SynonymFilter/FilterSection/FilterSection.vue";
import FilterOptions from "@/components/Synonym/SynonymFilter/FilterOptions/FilterOptions.vue";

export default {
    components: {
        FilterSection,
        FilterOptions
    },
    data() {
        return {
            activePosFilters: [],
            activeCategoryFilters: []
        };
    },
    computed: {
        ...mapGetters("ThesaurusFilter", ["getFiltersObj", "getActiveFiltersAmount"])
    },
    methods: {
        ...mapActions("ThesaurusFilter", ["toggleMobileFilterPanel"])
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymFilter/DesktopSynonymFilter/DesktopSynonymFilter.js